import React, {useState, useEffect, useRef} from "react";
import {Badge, Button, Col, Row, Tabs} from "antd";
import ShiftScoreFilters from "./Components/ShiftScoreFilters";
import {useFetch} from "../../hooks/useFetch";
import {useHistory} from "react-router-dom";
import stores from "../../store/stores";
import ShiftScoreTable from "./Components/ShiftScoreTable";
import {t} from "i18next";
import moment from "moment";
import useIsFocused from "../../hooks/useIsFocused";
import {ButtonsRow, WaitingApproveButton} from "./ShiftScoreTableStyled";
import ShiftScoreModal from "./Components/ShiftScoreModal/ShiftScoreModal";
import FutureShiftsTable from "./Components/FutureShiftsTable";
import FutureShiftsFilters from "./Components/FutureShiftsFilters";
import {CustomButton} from "../_defaultComponents/CustomButton/CustomButton";
import {DownloadOutlined} from "@ant-design/icons";
const {TabPane} = Tabs;

const ShiftScore = () => {
    const history = useHistory();
    const [currentPage, setCurrentPage] = useState(1);
    const [futureCurrentPage, setFutureCurrentPage] = useState(1);
    const [reloadCount, setReloadCount] = useState(false);
    const [applyWaitingApproveFilters, setApplyWaitingApproveFilters] = useState(false);
    const [reloadData, setReloadData] = useState({});
    const [recall, setRecall] = useState(true);
    const [tabKey, setTabKey] = useState("activeShifts");
    const isFocused = useIsFocused();

    const recallRef = useRef(recall);
    recallRef.current = recall;

    useEffect(() => {
        console.log(tabKey);
    }, [tabKey]);

    useEffect(() => {
        if (isFocused) {
            let timeout = null;

            timeout = setTimeout(async () => {
                await setRecall(!recallRef.current);
            }, 30000);

            return () => clearTimeout(timeout);
        }
    }, [recall, isFocused]);

    const [filters, setFilters] = useState({
        company: undefined,
        subCompany: undefined,
        period: "today",
        startDate: moment()
            .subtract(1, "d")
            .toDate(),
        endDate: moment().toDate(),
        status: "all",
        city: "all",
        currentStatus: "all" //currently Active or Inactive Courier Status
    });

    const [futureShiftsFilters, setFutureShiftsFilters] = useState({
        company: undefined,
        subCompany: undefined,
        period: "today",
        startDate: moment()
            .subtract(1, "d")
            .toDate(),
        endDate: moment().toDate(),
        city: "all",
        currentStatus: "all"
    });

    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: stores.shiftStore.getShiftScoreList.bind(null, {
            limit: 10,
            skip: (currentPage - 1) * 10,
            companies: filters.company ? [filters.company] : ["all"],
            subcompanies: filters.subCompany,
            period: filters.period,
            startDate: filters.startDate,
            endDate: filters.endDate,
            status: filters.status,
            city: filters.city,
            currentStatus: filters.currentStatus
        }),
        dependencies: [filters, currentPage, reloadData, recall]
    });

    const [futureLoading, futureData, setFutureData, setFutureLoading] = useFetch({
        fetchFn: stores.shiftStore.getFutureShiftsList.bind(null, {
            limit: 10,
            skip: (futureCurrentPage - 1) * 10,
            companies: futureShiftsFilters.company ? [futureShiftsFilters.company] : ["all"],
            subcompanies: futureShiftsFilters.subCompany,
            period: futureShiftsFilters.period,
            startDate: futureShiftsFilters.startDate,
            endDate: futureShiftsFilters.endDate,
            city: futureShiftsFilters.city,
            currentStatus: futureShiftsFilters.currentStatus
        }),
        dependencies: [futureShiftsFilters, futureCurrentPage, reloadData, recall]
    });

    const [, count, ,] = useFetch({
        defaultDataValue: 0,
        initialCall: true,
        fetchFn: stores.shiftStore.getWaitingApproveCount.bind(null, {}),
        dependencies: [reloadData, recall, reloadCount],
        condition: stores.meStore.checkRole("isCompanyUser")
    });

    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const changeTab = value => {
        setTabKey(value);
        setCurrentPage(1);
        setFutureCurrentPage(1);
        setIsModalOpen(false);
    };

    return (
        <div>
            <ShiftScoreModal
                visible={isModalOpen}
                onCancel={handleCancel}
                setIsModalOpen={setIsModalOpen}
            />
            <Tabs activeKey={tabKey} onChange={changeTab}>
                <TabPane tab="Aktif Vardiyalar" key="activeShifts">
                    <Row align="middle">
                        <Col span={16} xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Row gutter={[8, 8]}>
                                <ShiftScoreFilters
                                    setCurrentPage={setCurrentPage}
                                    setFilters={setFilters}
                                    filters={filters}
                                    applyWaitingApproveFilters={applyWaitingApproveFilters}
                                    setApplyWaitingApproveFilters={setApplyWaitingApproveFilters}
                                />
                            </Row>
                        </Col>
                    </Row>
                    <Row align="middle" justify="end">
                        <Col span={24} sm={24} md={24} lg={24} xl={24}>
                            <ButtonsRow>
                                {filters?.currentStatus && filters?.currentStatus !== "all" ? (
                                    <>
                                        <CustomButton
                                            type="primary"
                                            data-testid="exportWithExcelButton"
                                            onClick={async () => {
                                                const data = {...filters};
                                                const response = await stores.shiftStore.exportShiftScoreListByCurrentStatus(
                                                    data
                                                );
                                                let link = document.createElement("a");
                                                link.href = response;
                                                link.download = `vardiya-durum-raporu-${moment().format(
                                                    "YYYY-MM-DD-HH-mm-ss"
                                                )}.xlsx`;
                                                document.body.appendChild(link);
                                                link.click();
                                                setTimeout(function() {
                                                    window.URL.revokeObjectURL(link);
                                                }, 200);
                                            }}
                                            icon={<DownloadOutlined />}
                                        >
                                            {t("companyDetail.actions.exportWithExcel", {
                                                ns: "companyDetail"
                                            })}
                                        </CustomButton>
                                    </>
                                ) : (
                                    <></>
                                )}
                                {stores.meStore.checkRole("isCompanyUser") && count > 0 ? (
                                    <Badge count={count} style={{zIndex: 3}}>
                                        <WaitingApproveButton
                                            style={{color: "red"}}
                                            onClick={() => setApplyWaitingApproveFilters(true)}
                                        >
                                            {t("shiftScore.shiftStatuses.waitingApprove", {
                                                ns: "shiftScore"
                                            })}
                                        </WaitingApproveButton>
                                    </Badge>
                                ) : (
                                    ""
                                )}
                                <>
                                    <Button
                                        onClick={() =>
                                            history.push("/reports/shift-score/objections")
                                        }
                                    >
                                        {t("screens.shiftReportObjections", {ns: "common"})}
                                    </Button>
                                    {!stores.meStore.checkRole("isCompanyUser") && (
                                        <Button onClick={showModal}>
                                            {t("shiftScore.actions.addShiftScore", {
                                                ns: "shiftScore"
                                            })}
                                        </Button>
                                    )}
                                </>
                            </ButtonsRow>
                        </Col>
                    </Row>
                    <Row>
                        <ShiftScoreTable
                            loading={loading}
                            data={data?.rows || []}
                            setData={setData}
                            dataCount={data?.dataCount}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            setReloadData={() => setReloadData(!reloadData)}
                            setReloadCount={() => setReloadCount(!reloadCount)}
                            filters={filters}
                        />
                    </Row>
                </TabPane>
                <TabPane tab="Gelecek Vardiyalar" key="futureShifts">
                    <Row align="middle">
                        <Col span={16} xs={24} sm={24} md={24} lg={24} xl={18}>
                            <Row gutter={[8, 8]}>
                                <FutureShiftsFilters
                                    setCurrentPage={setFutureCurrentPage}
                                    setFilters={setFutureShiftsFilters}
                                    filters={futureShiftsFilters}
                                />
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <FutureShiftsTable
                            loading={futureLoading}
                            data={futureData?.rows || []}
                            setData={setFutureData}
                            dataCount={futureData?.dataCount}
                            currentPage={futureCurrentPage}
                            setCurrentPage={setFutureCurrentPage}
                            setReloadData={() => setReloadData(!reloadData)}
                            setReloadCount={() => setReloadCount(!reloadCount)}
                        ></FutureShiftsTable>
                    </Row>
                </TabPane>
            </Tabs>
        </div>
    );
};

export default ShiftScore;
